<template>
	<div class="add_backimg">
		<div class="content minheight clearfix">
			<div class="left_types">
				<div class="left_search">
					<div class="left_searchTitle">新闻资讯</div>
					<span class="left_searchEn">NEWS INFORMATION</span>
				</div>
				<div class="left_newsFilter clearfix">
					<div class="left_newsItem active">
						校内资讯
					</div>
				</div>
			</div>
			<div class="new_list">
				<div class="new_rightTop">
					校内资讯/NEWS
				</div>
				<div class="new_listMain">
					<div class="new_listItem clearfix" :class="item.cover?'hascover':''" v-for="item in noticeList" @click="toDetails(item)">
						<div class="new_listIcon coverItem" v-if="item.cover">
							<img :src="baseurl + item.cover" />
						</div>
						<div class="new_listDate">
							<div class="new_listDay">{{item.releaseTime | spliceForDay}}</div>
							<div class="new_listMonth">{{item.releaseTime | spliceForYear}}</div>
						</div>
						<div class="new_listInfo clearfix">
							<div class="new_listTitle text-ellipsis">{{item.title}}</div>
							<div class="new_listDesc text-ellipsistwo">{{item.description}}</div>
							<div class="new_listOther clearfix">
								<div class="new_listIn">校内资讯</div>
								<div class="new_listNum">{{item.readCount || 0}}人已读</div>
								<img src="@/images/new_listRight.png" class="new_listRight" />
								<img src="@/images/new_listRightAct.png" class="new_listRightAct" />
							</div>
						</div>
					</div>
				</div>
				<div class="all_current">
					<el-pagination prev-text='上一页' next-text='下一页' background @current-change="handleCurrentChange" :current-page="current" :page-size="limit" layout="total,  prev, pager, next" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { noticeList } from '@/api/notice'
	export default {
		name: 'news',
		data() {
			return {
				limit: 10,
				current: 1,
				total: 0,
				noticeList: []
			}
		},
		created() {
			this.getNotice();
		},
		mounted() {},
		methods: {
			toDetails(item) {
				this.$router.push({
					name: "newsdetail",
					query: {
						id: item.id
					}
				})
			},
			handleCurrentChange(current) {
				this.current = current;
				this.getNotice()
			},
			//获取当前用户所能查看公告
			getNotice() {
				noticeList({
					current: this.current,
					limit: this.limit,
					state: 1
				}).then(res => {
					this.noticeList = res.data.records;
					this.total = res.data.total;
				})
			},
		},
	}
</script>